import { useAuth, overrideConfig } from '@/api/cost-search'

const fetchUserTag = function (serviceIdx) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    return auth.axiosIns.get('/v1/api/usertag')
}
const fetchDynamicSearch = function ({ qtype, projectIdx, groupIdx, filter, indexes }, serviceIdx) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    const params = {
        groupIdx,
        projectIdx,
        indexes,
        filter
    }
    return auth.axiosIns.post(`/v1/api/dynamic/qtype/${qtype}`, params)
}

const fetchDynamicSearchItemDescription = function ({ qtype, projectIdx, groupIdx, filter }, serviceIdx) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    const params = {
        groupIdx,
        projectIdx,
        filter
    }
    return auth.axiosIns.post(`/v1/api/dynamic/detail/qtype/${qtype}`, params)
}

export default {
    fetchUserTag,
    fetchDynamicSearch,
    fetchDynamicSearchItemDescription
}
